<template>
    <span class="formit-checkbox-wrapper">
        <label :for="name">
            <input
                ref="input"
                type="checkbox"
                :name="name"
                v-bind="attributes"
                :checked="currentValue"
                @change="handleChange"
            >
        </label>
    </span>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-checkbox',
	mixins: [basefield],
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/checkbox/checkbox.vue